import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import useCrudTable from "../../../../hooks/useCrudTable";
import useCrudFilters from "../../../../hooks/useCrudFilters";
import { userSchema } from "../../domain/models/userModel";
import { UserTableColumns } from "../../domain/columns/userTableColumns";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { UserTableFilters } from "../features/UserTableFilters";

export const UserPage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");
  const title = t("Users");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootUser",
      fields: {},
    },
    "userFilter",
  );

  const crud = useCrudTable({
    prefix: "users",
    entity: "User",
    columns: UserTableColumns,
    schema: userSchema,
    addAction: "/user/add",
    columnAction: "/user/edit/:id",
    filters: crudFilters.filters,
    queryExclude: ["password"],
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
            <div>
              <LayoutHeaderTitle title={title} />
            </div>
            <div className="flex-grow-1 mx-md-3 my-2 my-md-0">
              <Breadcrumb>
                <BreadCrumbItem>{title}</BreadCrumbItem>
              </Breadcrumb>
            </div>
            <div className="mt-2 mb-2 mt-md-0">
              <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
            </div>
          </div>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className={"mb-3"} />
          <UserTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
